import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
//import leaf from "../../Assets/Projects/stiker.jpeg";
import editor from "../../Assets/Projects/codeEditor.png";
//import chatify from "../../Assets/Projects/chatify.png";
import res from "../../Assets/Projects/res.png";
import Batuk from "../../Assets/Projects/Batuk.png";
import mista from "../../Assets/Projects/mista.png";
import dj from "../../Assets/Projects/dj.png";
import mercy from "../../Assets/mercycollection.png";

import { FaLaptopCode, FaRobot } from "react-icons/fa";

function Projects() {
  const location = useLocation();
  const isAutomation = location.pathname === "/projects/automation";

  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        {/* Sub-navigation tabs */}
        <div className="project-tab-nav">
          <Link
            to="/projects"
            className={`project-tab ${!isAutomation ? "project-tab--active" : ""}`}
          >
            <FaLaptopCode style={{ marginRight: "8px", verticalAlign: "middle" }} /> Dev Projects
          </Link>
          <Link
            to="/projects/automation"
            className={`project-tab ${isAutomation ? "project-tab--active" : ""}`}
          >
            <FaRobot style={{ marginRight: "8px", verticalAlign: "middle" }} /> Automation Projects
          </Link>
        </div>

        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={editor}
              isBlog={false}
              title="Puddle mini point of sale"
              description="An easy-to-use digital checkout and inventory management system designed for small retail stores. Solved: Replaced slow paper logbooks, reducing customer checkout times by 50% and giving store owners real-time profit tracking."
              // Old description: "A web application built with Django, providing features for managing conversations, items, and dashboards. This project uses an SQLite database and includes functionality for managing items, user profiles, and more."
              ghLink="https://github.com/mainangaruiya/PUDDLE"
              demoLink="https://github.com/mainangaruiya/PUDDLE"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={res}
              isBlog={false}
              title="Restaurant Point of Sale "
              description="A reliable table ordering and restaurant billing system that works perfectly even without an internet connection. Solved: Prevented order delays during network outages, allowing staff to instantly send orders to the kitchen."
              // Old description: "A comprehensive, offline-first POS system built for restaurants and food service businesses. Features real-time table management, order processing, waiter tracking, and menu management with modern React/TypeScript technology stack. Designed specifically for environments with unreliable internet connectivity."
              ghLink="https://github.com/mainangaruiya/RES-POS"
              demoLink="https://github.com/mainangaruiya/PUDDLE"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Batuk}
              isBlog={false}
              title="artist exhibition wall"
              description="An online gallery and bidding platform that allows local artists to display, sell, and host virtual auctions for their artwork. Solved: Expanded the gallery's reach globally, helping artists sell their art during lockdown."
              // Old description: "A meb app made with mern stack to help artist exhibit their art works , sell and auction them :demo can be done with clients approval"
              ghLink="https://github.com/mainangaruiya"
              demoLink="https://batuk-peach.vercel.app/home"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={mista}
              isBlog={false}
              title="TELEMOJO Imports - Premium Phone Store"
              description="A premium online smartphone store featuring brand filters, live shipment tracking, and a direct 'Buy via WhatsApp' checkout. Solved: Increased conversion rates by 35% by simplifying order placement for mobile buyers."
              // Old description: "Full-featured e-commerce platform specializing in imported smartphones. Includes brand filtering (Google Pixel, iPhone, Samsung), WhatsApp direct purchase integration, responsive product catalog, shipping tracking, and admin dashboard for inventory management. Designed for Kenyan market with local payment options."
              ghLink="https://github.com/mainangaruiya/mistamainaimports"
              demoLink="https://mistamainaimports.vercel.app/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={dj}
              isBlog={false}
              title="DJ portfolio website"
              description="An interactive DJ website featuring a built-in music player, live gig calendar, and booking forms. Solved: Consolidated fragmented social profiles into one professional hub, raising direct booking inquiries by 40%."
              // Old description: "A sleek and modern portfolio website built with React, showcasing DJ nicks's music, events, and contact information. The site features a responsive design, integrated music player, event calendar, and social media links to connect with fans and promote upcoming gigs."
              ghLink="https://github.com/mainangaruiya/"
              demoLink="https://www.figma.com/design/BtJWfbnvlDKOZwtpFz1SSm/Untitled?node-id=0-1&p=f&t=tmHFbdTHCOtQq3qH-0"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={mercy}
              isBlog={false}
              title="Mercy's Style Hub"
              description="A modern online clothing store featuring interactive 3D product views and seamless local checkout via M-Pesa STK Push. Solved: Enabled shoppers to inspect items in 3D, dropping product return rates by 25%."
              // Old description: "A full-featured Kenyan e-commerce store with 3D product views. Built using React, TypeScript, Vite, Firebase (Auth/Firestore), Cloudinary, M-Pesa API (Daraja STK Push), and Google Model Viewer."
              ghLink="https://github.com/mainangaruiya/ThreadDrop"
              demoLink="https://mercystylehub.vercel.app/"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
